import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import ProjectLinks from 'src/app/common/project.links';
import { CategoryBasicView, OrganizationLink } from 'src/app/swagger-api';
import { OrganizationLinkUrlParams } from '../../organization-link-view/organization-link.interfaces';

@Directive()
export abstract class ProfessionalRolBaseComponent implements OnChanges {
  public organizationLinkUrlParams: OrganizationLinkUrlParams[];

  @Input({ required: false }) public fellowship: string;
  @Input({ required: false }) public treatmentDiseases: CategoryBasicView[];
  @Input({ required: true }) public specialtys: CategoryBasicView[];
  @Input({ required: true }) public organizationNames: OrganizationLink[];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['organizationNames'].currentValue) {
      this.organizationLinkUrlParams = this.prepareOrganizationLinks(
        changes['organizationNames'].currentValue as OrganizationLink[],
      );
    }
  }

  public isCustomOrganization(organization: OrganizationLink): boolean {
    return organization.organization_link_kind === OrganizationLink.OrganizationLinkKindEnum.CUSTOM;
  }

  public prepareRouterUrlParams(organizationLink: OrganizationLink): OrganizationLinkUrlParams {
    if (this.isCustomOrganization(organizationLink)) {
      return {
        isCustom: true,
        organization_name: organizationLink.organization_name,
      };
    } else {
      return {
        organization_name: organizationLink.organization_name,
        url: `${ProjectLinks.LINK_PROFILE_VIEW}/${organizationLink.organization_user_id}`,
      };
    }
  }

  private prepareOrganizationLinks(organizationLinks: OrganizationLink[]): OrganizationLinkUrlParams[] {
    return organizationLinks.map((organizationLink: OrganizationLink) => {
      return this.prepareRouterUrlParams(organizationLink);
    });
  }
}
